import React, { useEffect, useState } from 'react'
import Slider from 'react-slick'
import Review from './Review'
import axios from 'axios';

const reviewsettings = {
    dots: false,
    slidesToShow: 3,
    rows: 1,
    speed: 300,
    cssEase: "linear",
    arrows: true,
    responsive: [
        {
        breakpoint: 768,
        settings: {
            slidesToShow: 1.8,
        },
        },
        {
        breakpoint: 480,
        settings: {
            slidesToShow: 1.1,
            infinite: false,
            dots: false,
            swipeToSlide: true,
            arrows: false
        },
        },
    ],
};

const ReviewSection = ({ reviewStories }) => {

    const [ reviews, setReviews ] = useState([])
    const [ showMoreAction, setShowMoreAction ] = useState(Array(reviewStories?.length).fill(false))
    const [ isloading, setIsLoading ] = useState(false)


    useEffect(() => {
        setIsLoading(true)
        const fetchReviews = async () => {      
            try {
                const response = await axios.get('https://xgfy-czuw-092q.m2.xano.io/api:HYL0rVog/pricing_page/reviews');
                await setReviews(response.data)
                setShowMoreAction(Array(response?.data?.length).fill(false))
            } catch (err) {
                console.log(err);
            }finally {
                setIsLoading(false)
            }
        }
        fetchReviews()
    }, [])
    
    const handleShowMore = (index) => {
        let newArray = [...showMoreAction]
        newArray[index] = !showMoreAction[index]
        setShowMoreAction(newArray)
    }
    
    return (
        <div className=''>
            {isloading ? <div className='w-full flex gap-1 '>
                <div className='w-1/3 bg-[#2D4F71] h-[200px] rounded-lg animate-pulse'></div>
                <div className='w-1/3 bg-[#2D4F71] h-[200px] rounded-lg animate-pulse'></div>
                <div className='w-1/3 bg-[#2D4F71] h-[200px] rounded-lg animate-pulse'></div>
            </div> : 
            reviews?.length > 0 && <Slider {...reviewsettings}>
            {reviews?.map((reviewData, index) => (
                <Review key={index} index={index} showMore={showMoreAction[index]} handleShowMore={handleShowMore} reviewData={reviewData}/>
            ))}
            </Slider>}
        </div>
    )
}

export default ReviewSection